var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-outer rounded"},[_c('div',{staticClass:"message"},[_c('h1',[_vm._v(_vm._s(_vm.message.header))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message.body)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }